import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SsoService {
  private loginSso = environment.API_BASE + '/Clients/AuthSso/{clientId}';
  private logoutSso = environment.API_BASE + '/Clients/LogoutSso/{clientId}';

  private inventarioUsuariosSSO = environment.API_BASE + '/Users/LoadExcelDireccionesUser';

  constructor(private http: HttpClient) { }

  getUrlAuthSsoClient(clientId: string): Observable<string> {
    return this.http.get<string>(this.loginSso.replace('{clientId}', clientId.toString()));
  }

  getUrlLogoutSsoClient(clientId: string): Observable<string> {
    return this.http.get<string>(this.logoutSso.replace('{clientId}', clientId.toString()));
  }

  loadExcelInventarioUsuarios(fileData: any): Observable<{ isok: boolean, updated: number, inserted: number, deleted: number, msg: string }> {
    const formData = new FormData();
    formData.append('file', fileData);
    return this.http.post<{ isok: boolean, updated: number, inserted: number, deleted: number, msg: string }>(
      this.inventarioUsuariosSSO,
      formData);
  }

}
